export default {
  section: 'Pedido inteligente',
  loading: 'Cargando productos...',
  headers: {
    name: 'Nombre',
    category: 'Categoría',
    provider: 'Proveedor',
    stock: 'Stock semanal',
    quantityCalculated: {
      buyer: 'Cantidad calculada',
      manager: 'Cantidad calculada',
      stockmanager: 'Cantidad calculada'
    },
    purchaseOrder: 'Cantidad a comprar'
  }
}
